// import React, { useEffect, useMemo, useRef, useState } from "react";
// import styles from "./StaffDetailModal.module.css";
// import {
//   STATUS_COLORS,
//   MONTH_NAMES,
//   buildMonthGrid,
//   buildSalarySlip,
//   buildPaidHistory,
//   getYearOptions,
//   formatDateTime,
//   monthOptions,
// } from "./HrmData";
// import { openPrintableSlip } from "./PrintableSlipDocument";

// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import {
//   buildAttendanceReceiptXml,
//   buildHistoryReceiptXml,
//   buildSalarySlipReceiptXml,
//   buildTotalPaidReceiptXml,
//   EPSON_DEFAULT_PORT,
//   sendEposPrint,
// } from "./Epsonreceipthelpers";
// const EDITABLE_STATUSES = ["Present", "Absent", "Half-Day", "Leave"];

// const StaffDetailModal = ({
//   employee,
//   records,
//   mode,
//   initialYear,
//   initialMonth,
//   onClose,
//   onUpdateStatus,
//   onUpdateSalary,
//   history = [],
//   companyName = "Wallicon Pvt. Ltd.",
// }) => {
//   const { show } = useToast();
//   const today = new Date();
//   const [year, setYear] = useState(initialYear ?? today.getFullYear());
//   const [month, setMonth] = useState(initialMonth ?? today.getMonth());
//   const [tab, setTab] = useState("salary"); // "attendance" | "salary" | "paidHistory" | "history"
//   const [editingDate, setEditingDate] = useState(null); // date currently showing the status popover
//   const [salaryDraft, setSalaryDraft] = useState(
//     String(employee.monthlySalary),
//   );
//   const popoverRef = useRef(null);
//   const [IPs, setIPs] = useState();
//   const [printingSection, setPrintingSection] = useState(null); // which Epson print is in flight, for button disabling

//   useEffect(() => {
//     const storedIPs = localStorage.getItem("printerIPs");
//     if (storedIPs) {
//       setIPs(JSON.parse(storedIPs));
//     }
//   }, []);

//   useEffect(
//     () => setSalaryDraft(String(employee.monthlySalary)),
//     [employee.monthlySalary],
//   );

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (popoverRef.current && !popoverRef.current.contains(e.target)) {
//         setEditingDate(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const grid = useMemo(() => buildMonthGrid(year, month), [year, month]);
//   const yearOptions = useMemo(
//     () =>
//       getYearOptions(employee.joiningDate).map((year) => ({
//         label: year.toString(),
//         value: year,
//       })),
//     [employee.joiningDate],
//   );

//   const statusByDate = useMemo(() => {
//     const map = {};
//     records
//       .filter((r) => r.employeeId === employee.id)
//       .forEach((r) => (map[r.date] = r.status));
//     return map;
//   }, [records, employee.id]);

//   const slip = useMemo(
//     () => buildSalarySlip(employee, records, year, month),
//     [employee, records, year, month],
//   );
//   const paidHistory = useMemo(
//     () => buildPaidHistory(employee, records, year, month),
//     [employee, records, year, month],
//   );

//   const employeeHistory = useMemo(
//     () =>
//       history
//         .filter((h) => h.employeeId === employee.id)
//         .slice()
//         .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)),
//     [history, employee.id],
//   );

//   const goMonth = (delta) => {
//     let m = month + delta;
//     let y = year;
//     if (m < 0) {
//       m = 11;
//       y -= 1;
//     }
//     if (m > 11) {
//       m = 0;
//       y += 1;
//     }
//     setMonth(m);
//     setYear(y);
//   };

//   const handlePrint = () => {
//     const win = openPrintableSlip({
//       employee,
//       records,
//       year,
//       month,
//       history,
//       companyName,
//     });
//     if (!win) {
//       alert(
//         "Your browser blocked the print window pop-up. Please allow pop-ups for this site and try again.",
//       );
//     }
//   };

//   const handlePickStatus = (date, status) => {
//     onUpdateStatus?.(employee.id, date, status);
//     setEditingDate(null);
//   };

//   const handleSalaryBlur = () => {
//     const parsed = Number(salaryDraft);
//     if (!Number.isNaN(parsed) && parsed >= 0) {
//       onUpdateSalary?.(employee.id, parsed);
//     } else {
//       setSalaryDraft(String(employee.monthlySalary));
//     }
//   };

//   const printLabel = "Full Report";

//   const fmtDate = (iso) =>
//     new Date(iso).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });

//   // ─── Thermal (Epson ePOS) printing ───────────────────────────────────
//   // `section` is one of "salary" | "attendance" | "history" | "paidHistory".
//   // Builds the receipt XML for just that report and POSTs it straight to
//   // the configured printer — no browser print dialog involved.
//   const handleEpsonPrint = async (section) => {
//     const printerIp = IPs?.salary;
//     const printerPort = EPSON_DEFAULT_PORT;

//     if (!printerIp) {
//       show("Printer's IP for salary slip is missing!", "error");
//       return;
//     }

//     let xml;
//     switch (section) {
//       case "salary":
//         xml = buildSalarySlipReceiptXml({
//           employee,
//           slip,
//           year,
//           month,
//           companyName,
//         });
//         break;
//       case "attendance":
//         xml = buildAttendanceReceiptXml({
//           employee,
//           statusByDate,
//           year,
//           month,
//           companyName,
//         });
//         break;
//       case "history":
//         xml = buildHistoryReceiptXml({
//           employee,
//           employeeHistory,
//           companyName,
//         });
//         break;
//       case "paidHistory":
//         xml = buildTotalPaidReceiptXml({
//           employee,
//           paidHistory,
//           year,
//           month,
//           companyName,
//         });
//         break;
//       default:
//         return;
//     }

//     setPrintingSection(section);
//     const result = await sendEposPrint(printerIp, printerPort, xml);
//     setPrintingSection(null);

//     if (result.success) {
//       show("Sent to printer.", "success");
//     } else {
//       show(result.message || "Print failed.", "error");
//     }
//   };

//   return (
//     <div className={styles.overlay} onClick={onClose}>
//       <div
//         className={`${styles.card} ${mode ? styles.cardDark : ""}`}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <button type="button" className={styles.closeBtn} onClick={onClose}>
//           &times;
//         </button>

//         <div className={styles.header}>
//           <div>
//             <h2 className={styles.name}>{employee.name}</h2>
//             <p className={styles.subtext}>
//               {employee.staffId} &middot; {employee.department} &middot;{" "}
//               {employee.shift} shift
//             </p>
//             <p className={styles.subtext}>
//               Joined {fmtDate(employee.joiningDate)}
//             </p>
//           </div>

//           <div className={styles.tabs}>
//             <button
//               type="button"
//               className={`${styles.tabBtn} ${tab === "salary" ? styles.tabBtnActive : ""}`}
//               onClick={() => setTab("salary")}
//             >
//               Salary Slip
//             </button>
//             <button
//               type="button"
//               className={`${styles.tabBtn} ${tab === "attendance" ? styles.tabBtnActive : ""}`}
//               onClick={() => setTab("attendance")}
//             >
//               Attendance
//             </button>

//             <button
//               type="button"
//               className={`${styles.tabBtn} ${tab === "paidHistory" ? styles.tabBtnActive : ""}`}
//               onClick={() => setTab("paidHistory")}
//             >
//               Total Paid
//             </button>
//             <button
//               type="button"
//               className={`${styles.tabBtn} ${tab === "history" ? styles.tabBtnActive : ""}`}
//               onClick={() => setTab("history")}
//             >
//               History
//             </button>
//           </div>
//         </div>

//         <div className={styles.monthBar}>
//           <button
//             type="button"
//             className={styles.monthNavBtn}
//             onClick={() => goMonth(-1)}
//           >
//             &#8249;
//           </button>

//           <div className={styles.monthFilter}>
//             <DropDown
//               label="Month"
//               value={month}
//               options={monthOptions}
//               onSelect={(val) => setMonth(Number(val.value))}
//             />
//             <DropDown
//               label="Year"
//               value={year}
//               options={yearOptions}
//               onSelect={(val) => setYear(Number(val.value))}
//             />
//           </div>
//           <button
//             type="button"
//             className={styles.monthNavBtn}
//             onClick={() => goMonth(1)}
//           >
//             &#8250;
//           </button>

//           <button
//             type="button"
//             className={styles.printBtn}
//             onClick={handlePrint}
//           >
//             Print {printLabel}
//           </button>
//         </div>

//         <div className={styles.epsonRow}>
//           <span className={styles.epsonLabel}>Thermal Printer:</span>
//           <button
//             type="button"
//             className={styles.epsonBtn}
//             disabled={printingSection === "salary"}
//             onClick={() => handleEpsonPrint("salary")}
//           >
//             {printingSection === "salary" ? "Printing…" : "Salary Slip"}
//           </button>
//           <button
//             type="button"
//             className={styles.epsonBtn}
//             disabled={printingSection === "attendance"}
//             onClick={() => handleEpsonPrint("attendance")}
//           >
//             {printingSection === "attendance" ? "Printing…" : "Attendance"}
//           </button>
//           <button
//             type="button"
//             className={styles.epsonBtn}
//             disabled={printingSection === "paidHistory"}
//             onClick={() => handleEpsonPrint("paidHistory")}
//           >
//             {printingSection === "paidHistory" ? "Printing…" : "Total Paid"}
//           </button>
//           <button
//             type="button"
//             className={styles.epsonBtn}
//             disabled={printingSection === "history"}
//             onClick={() => handleEpsonPrint("history")}
//           >
//             {printingSection === "history" ? "Printing…" : "History"}
//           </button>
//         </div>

//         {tab === "attendance" && (
//           <>
//             <div className={styles.legend}>
//               {EDITABLE_STATUSES.map((s) => (
//                 <span key={s} className={styles.legendItem}>
//                   <i style={{ background: STATUS_COLORS[s].border }} />
//                   {s}
//                 </span>
//               ))}
//               <span className={`${styles.legendItem} ${styles.legendHint}`}>
//                 Click a day to edit
//               </span>
//             </div>

//             <div className={styles.weekRow}>
//               {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
//                 <div key={d} className={styles.weekHead}>
//                   {d}
//                 </div>
//               ))}
//             </div>

//             <div className={styles.calendarGrid}>
//               {grid.map((date, idx) => {
//                 if (!date)
//                   return <div key={idx} className={styles.dayCellEmpty} />;
//                 const status = statusByDate[date];
//                 const color = status ? STATUS_COLORS[status] : null;
//                 const dayNum = Number(date.slice(-2));
//                 const isEditing = editingDate === date;

//                 return (
//                   <div key={date} className={styles.dayCellWrap}>
//                     <button
//                       type="button"
//                       className={styles.dayCell}
//                       style={
//                         color
//                           ? {
//                               background: mode ? color.dark : color.light,
//                               borderColor: color.border,
//                             }
//                           : {}
//                       }
//                       onClick={() => setEditingDate(isEditing ? null : date)}
//                       title={status || "No record — click to set"}
//                     >
//                       <span className={styles.dayNum}>{dayNum}</span>
//                       {status && (
//                         <span className={styles.dayStatus}>{status}</span>
//                       )}
//                     </button>

//                     {isEditing && (
//                       <div
//                         ref={popoverRef}
//                         className={`${styles.dayPopover} ${mode ? styles.dayPopoverDark : ""}`}
//                       >
//                         {EDITABLE_STATUSES.map((s) => (
//                           <button
//                             key={s}
//                             type="button"
//                             className={styles.dayPopoverItem}
//                             style={{ color: STATUS_COLORS[s].border }}
//                             onClick={() => handlePickStatus(date, s)}
//                           >
//                             <i
//                               style={{ background: STATUS_COLORS[s].border }}
//                             />
//                             {s}
//                           </button>
//                         ))}
//                         {status && (
//                           <button
//                             type="button"
//                             className={`${styles.dayPopoverItem} ${styles.dayPopoverClear}`}
//                             onClick={() => handlePickStatus(date, null)}
//                           >
//                             Clear
//                           </button>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>

//             <div className={styles.summaryRow}>
//               <div>
//                 <strong>{slip.counts.Present}</strong>
//                 <span>Present</span>
//               </div>
//               <div>
//                 <strong>{slip.counts.Absent}</strong>
//                 <span>Absent</span>
//               </div>
//               <div>
//                 <strong>{slip.counts["Half-Day"]}</strong>
//                 <span>Half-Day</span>
//               </div>
//               <div>
//                 <strong>{slip.counts.Leave}</strong>
//                 <span>Leave</span>
//               </div>
//               <div>
//                 <strong>{slip.unmarkedDays}</strong>
//                 <span>Unmarked</span>
//               </div>
//             </div>
//           </>
//         )}

//         {tab === "salary" && (
//           <div className={styles.slip}>
//             <table className={styles.slipTable}>
//               <tbody>
//                 <tr>
//                   <td>Days in month</td>
//                   <td>{slip.daysInMonth}</td>
//                 </tr>
//                 <tr>
//                   <td>Present</td>
//                   <td>{slip.counts.Present}</td>
//                 </tr>
//                 <tr>
//                   <td>Half-Day</td>
//                   <td>{slip.counts["Half-Day"]}</td>
//                 </tr>
//                 <tr>
//                   <td>Absent</td>
//                   <td>{slip.counts.Absent}</td>
//                 </tr>
//                 <tr>
//                   <td>Leave</td>
//                   <td>{slip.counts.Leave}</td>
//                 </tr>
//                 <tr>
//                   <td>Payable days</td>
//                   <td>{slip.payableDays}</td>
//                 </tr>
//                 <tr>
//                   <td>Per-day rate</td>
//                   <td>&#8377;{slip.dailyRate.toFixed(2)}</td>
//                 </tr>
//                 <tr className={styles.slipDivider}>
//                   <td colSpan={2} />
//                 </tr>
//                 <tr>
//                   <td>Gross salary</td>
//                   <td>
//                     <span className={styles.salaryEditWrap}>
//                       &#8377;{" "}
//                       <input
//                         type="number"
//                         min="0"
//                         className={styles.salaryInput}
//                         value={salaryDraft}
//                         onChange={(e) => setSalaryDraft(e.target.value)}
//                         onBlur={handleSalaryBlur}
//                         onKeyDown={(e) =>
//                           e.key === "Enter" && e.currentTarget.blur()
//                         }
//                       />
//                     </span>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>Deductions</td>
//                   <td>- &#8377;{slip.deduction.toLocaleString("en-IN")}</td>
//                 </tr>
//                 <tr className={styles.slipTotal}>
//                   <td>Net pay</td>
//                   <td>&#8377;{slip.netPay.toLocaleString("en-IN")}</td>
//                 </tr>
//               </tbody>
//             </table>
//             <p className={styles.editHint}>
//               Edit gross salary above — it recalculates net pay automatically.
//             </p>
//           </div>
//         )}

//         {tab === "paidHistory" && (
//           <div className={styles.paidHistory}>
//             <div className={styles.paidHeadline}>
//               <span>Total paid since joining</span>
//               <strong>
//                 &#8377;{paidHistory.totalPaid.toLocaleString("en-IN")}
//               </strong>
//             </div>
//             <p className={styles.subtext}>
//               {paidHistory.monthsCount} month
//               {paidHistory.monthsCount === 1 ? "" : "s"} counted, from{" "}
//               {fmtDate(paidHistory.joiningDate)} through {MONTH_NAMES[month]}{" "}
//               {year}.
//             </p>

//             <ul className={styles.paidHistoryList}>
//               <li className={styles.paidHistoryHeader}>
//                 <div>Month</div>
//                 <div>Present</div>
//                 <div>Absent</div>
//                 <div>Half-Day</div>
//                 <div>Net Paid</div>
//               </li>
//               {paidHistory.monthlySlips.map((s) => (
//                 <li
//                   key={`${s.year}-${s.month}`}
//                   className={styles.paidHistoryRow}
//                 >
//                   <div>
//                     {MONTH_NAMES[s.month]} {s.year}
//                   </div>
//                   <div>{s.counts.Present}</div>
//                   <div>{s.counts.Absent}</div>
//                   <div>{s.counts["Half-Day"]}</div>
//                   <div className={styles.netPayCell}>
//                     &#8377;{s.netPay.toLocaleString("en-IN")}
//                   </div>
//                 </li>
//               ))}
//             </ul>

//             <div className={styles.paidTotalsRow}>
//               <div>Gross across period</div>
//               <div>&#8377;{paidHistory.totalGross.toLocaleString("en-IN")}</div>
//             </div>
//             <div className={styles.paidTotalsRow}>
//               <div>Total deductions</div>
//               <div>
//                 - &#8377;{paidHistory.totalDeduction.toLocaleString("en-IN")}
//               </div>
//             </div>
//             <div
//               className={`${styles.paidTotalsRow} ${styles.paidTotalsGrand}`}
//             >
//               <div>Total paid</div>
//               <div>&#8377;{paidHistory.totalPaid.toLocaleString("en-IN")}</div>
//             </div>
//           </div>
//         )}

//         {tab === "history" && (
//           <div className={styles.historyTab}>
//             <p className={styles.subtext}>
//               Every attendance and salary edit made for {employee.name}, most
//               recent first.
//             </p>

//             {employeeHistory.length === 0 ? (
//               <p className={styles.historyEmpty}>
//                 No edits recorded yet — changes you make in Attendance or Salary
//                 Slip will show up here.
//               </p>
//             ) : (
//               <ul className={styles.historyList}>
//                 {employeeHistory.map((entry) => (
//                   <li key={entry.id} className={styles.historyRow}>
//                     <span
//                       className={styles.historyDot}
//                       style={{
//                         background:
//                           entry.type === "salary"
//                             ? "#4164E3"
//                             : STATUS_COLORS.default.border,
//                       }}
//                     />
//                     <div className={styles.historyBody}>
//                       <span className={styles.historyDescription}>
//                         {entry.description}
//                       </span>
//                       <span className={styles.historyTimestamp}>
//                         {formatDateTime(entry.timestamp)}
//                       </span>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default StaffDetailModal;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./EmployeeDetailModal.module.css";
import {
  STATUS_COLORS,
  MONTH_NAMES,
  buildMonthGrid,
  buildSalarySlip,
  buildPaidHistory,
  getYearOptions,
  formatDateTime,
  monthOptions,
} from "./HrmData";
import { openPrintableSlip } from "./PrintableSlipDocument";

import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import {
  buildAttendanceReceiptXml,
  buildHistoryReceiptXml,
  buildSalarySlipReceiptXml,
  buildTotalPaidReceiptXml,
  EPSON_DEFAULT_PORT,
  sendEposPrint,
} from "./Epsonreceipthelpers";
const EDITABLE_STATUSES = ["Present", "Absent", "Half-Day", "Leave"];

// Sizing estimates used only to position the portal-rendered day popover
// (decide whether it opens upward/downward, and to clamp it inside the
// viewport horizontally). Keep these roughly matching the actual CSS.
const DAY_POPOVER_WIDTH = 190;
const DAY_POPOVER_ITEM_HEIGHT = 32;
const DAY_POPOVER_EXTRA_HEIGHT = 24; // padding + divider/label rows

const EmployeeDetailModal = ({
  employee,
  records,
  mode,
  initialYear,
  initialMonth,
  onClose,
  onUpdateStatus,
  onUpdateSalary,
  history = [],
  companyName = "Wallicon Pvt. Ltd.",
  leaveTypes = [], // same leave-type list managed on the Attendance screen
}) => {
  const { show } = useToast();
  const today = new Date();
  const [year, setYear] = useState(initialYear ?? today.getFullYear());
  const [month, setMonth] = useState(initialMonth ?? today.getMonth());
  const [tab, setTab] = useState("salary"); // "attendance" | "salary" | "paidHistory" | "history"
  const [editingDate, setEditingDate] = useState(null); // date currently showing the status popover
  // Fixed viewport position for the portal-rendered day popover — computed
  // from the clicked day cell's bounding rect so the popover can never be
  // clipped by the modal card's own scroll container (see handleDayCellClick).
  const [popoverPos, setPopoverPos] = useState(null); // {top, left}
  const [salaryDraft, setSalaryDraft] = useState(
    String(employee.monthlySalary),
  );
  const popoverRef = useRef(null);
  const cardRef = useRef(null); // the modal's own scroll container
  const [IPs, setIPs] = useState();
  const [printingSection, setPrintingSection] = useState(null); // which Epson print is in flight, for button disabling

  useEffect(() => {
    const storedIPs = localStorage.getItem("printerIPs");
    if (storedIPs) {
      setIPs(JSON.parse(storedIPs));
    }
  }, []);

  useEffect(
    () => setSalaryDraft(String(employee.monthlySalary)),
    [employee.monthlySalary],
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      // Ignore clicks on any day cell — that's handled by the cell's own
      // toggle logic in handleDayCellClick, so we don't fight it and
      // accidentally close-then-reopen on the same click.
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target) &&
        !e.target.closest(`.${styles.dayCell}`)
      ) {
        setEditingDate(null);
        setPopoverPos(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close the popover if the modal body scrolls, so it doesn't end up
  // floating over the wrong part of the calendar.
  useEffect(() => {
    const cardEl = cardRef.current;
    if (!cardEl) return;
    const handleScroll = () => {
      setEditingDate(null);
      setPopoverPos(null);
    };
    cardEl.addEventListener("scroll", handleScroll);
    return () => cardEl.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (editingDate === null) return;
    const handleResize = () => {
      setEditingDate(null);
      setPopoverPos(null);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [editingDate]);

  const grid = useMemo(() => buildMonthGrid(year, month), [year, month]);
  const yearOptions = useMemo(
    () =>
      getYearOptions(employee.joiningDate).map((year) => ({
        label: year.toString(),
        value: year,
      })),
    [employee.joiningDate],
  );

  const statusByDate = useMemo(() => {
    const map = {};
    records
      .filter((r) => r.employeeId === employee.id)
      .forEach((r) => (map[r.date] = r.status));
    return map;
  }, [records, employee.id]);

  // Which leave type (if any) tags each date — mirrors the leaveType field
  // used on the Attendance table rows, but keyed by date for this employee.
  const leaveTypeByDate = useMemo(() => {
    const map = {};
    records
      .filter((r) => r.employeeId === employee.id)
      .forEach((r) => {
        if (r.leaveType) map[r.date] = r.leaveType;
      });
    return map;
  }, [records, employee.id]);

  const slip = useMemo(
    () => buildSalarySlip(employee, records, year, month),
    [employee, records, year, month],
  );
  const paidHistory = useMemo(
    () => buildPaidHistory(employee, records, year, month),
    [employee, records, year, month],
  );

  const employeeHistory = useMemo(
    () =>
      history
        .filter((h) => h.employeeId === employee.id)
        .slice()
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)),
    [history, employee.id],
  );

  const goMonth = (delta) => {
    let m = month + delta;
    let y = year;
    if (m < 0) {
      m = 11;
      y -= 1;
    }
    if (m > 11) {
      m = 0;
      y += 1;
    }
    setMonth(m);
    setYear(y);
  };

  const handlePrint = () => {
    const win = openPrintableSlip({
      employee,
      records,
      year,
      month,
      history,
      companyName,
    });
    if (!win) {
      alert(
        "Your browser blocked the print window pop-up. Please allow pop-ups for this site and try again.",
      );
    }
  };

  // `leaveType` defaults to null so status changes always explicitly set or
  // clear the leave type instead of silently carrying a stale one over.
  const handlePickStatus = (date, status, leaveType = null) => {
    onUpdateStatus?.(employee.id, date, status, leaveType);
    setEditingDate(null);
    setPopoverPos(null);
  };

  // Opens/closes the day popover and computes a viewport-fixed position for
  // it (rendered via portal below). This is what keeps the popover from
  // being clipped by the modal's own scroll container for dates near the
  // bottom of the calendar grid.
  const handleDayCellClick = (e, date) => {
    if (editingDate === date) {
      setEditingDate(null);
      setPopoverPos(null);
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const hasClear = Boolean(statusByDate[date] || leaveTypeByDate[date]);
    const totalRows =
      EDITABLE_STATUSES.length +
      (leaveTypes.length > 0 ? leaveTypes.length + 1 : 0) +
      (hasClear ? 1 : 0);
    const estimatedHeight =
      totalRows * DAY_POPOVER_ITEM_HEIGHT + DAY_POPOVER_EXTRA_HEIGHT;
    const spaceBelow = window.innerHeight - rect.bottom;
    const openUpward =
      spaceBelow < estimatedHeight && rect.top > estimatedHeight;

    const left = Math.min(
      Math.max(8, rect.left + rect.width / 2 - DAY_POPOVER_WIDTH / 2),
      window.innerWidth - DAY_POPOVER_WIDTH - 8,
    );

    setPopoverPos({
      left,
      top: openUpward ? rect.top - estimatedHeight - 6 : rect.bottom + 6,
    });
    setEditingDate(date);
  };

  const handleSalaryBlur = () => {
    const parsed = Number(salaryDraft);
    if (!Number.isNaN(parsed) && parsed >= 0) {
      onUpdateSalary?.(employee.id, parsed);
    } else {
      setSalaryDraft(String(employee.monthlySalary));
    }
  };

  const printLabel = "Full Report";

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  // ─── Thermal (Epson ePOS) printing ───────────────────────────────────
  // `section` is one of "salary" | "attendance" | "history" | "paidHistory".
  // Builds the receipt XML for just that report and POSTs it straight to
  // the configured printer — no browser print dialog involved.
  const handleEpsonPrint = async (section) => {
    const printerIp = IPs?.salary;
    const printerPort = EPSON_DEFAULT_PORT;

    if (!printerIp) {
      show("Printer's IP for salary slip is missing!", "error");
      return;
    }

    let xml;
    switch (section) {
      case "salary":
        xml = buildSalarySlipReceiptXml({
          employee,
          slip,
          year,
          month,
          companyName,
        });
        break;
      case "attendance":
        xml = buildAttendanceReceiptXml({
          employee,
          statusByDate,
          year,
          month,
          companyName,
        });
        break;
      case "history":
        xml = buildHistoryReceiptXml({
          employee,
          employeeHistory,
          companyName,
        });
        break;
      case "paidHistory":
        xml = buildTotalPaidReceiptXml({
          employee,
          paidHistory,
          year,
          month,
          companyName,
        });
        break;
      default:
        return;
    }

    setPrintingSection(section);
    const result = await sendEposPrint(printerIp, printerPort, xml);
    setPrintingSection(null);

    if (result.success) {
      show("Sent to printer.", "success");
    } else {
      show(result.message || "Print failed.", "error");
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        ref={cardRef}
        className={`${styles.card} ${mode ? styles.cardDark : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          &times;
        </button>

        <div className={styles.header}>
          <div>
            <h2 className={styles.name}>{employee.name}</h2>
            <p className={styles.subtext}>
              {employee.staffId} &middot; {employee.department} &middot;{" "}
              {employee.shift} shift
            </p>
            <p className={styles.subtext}>
              Joined {fmtDate(employee.joiningDate)}
            </p>
          </div>

          <div className={styles.tabs}>
            <button
              type="button"
              className={`${styles.tabBtn} ${tab === "salary" ? styles.tabBtnActive : ""}`}
              onClick={() => setTab("salary")}
            >
              Salary Slip
            </button>
            <button
              type="button"
              className={`${styles.tabBtn} ${tab === "attendance" ? styles.tabBtnActive : ""}`}
              onClick={() => setTab("attendance")}
            >
              Attendance
            </button>

            <button
              type="button"
              className={`${styles.tabBtn} ${tab === "paidHistory" ? styles.tabBtnActive : ""}`}
              onClick={() => setTab("paidHistory")}
            >
              Total Paid
            </button>
            <button
              type="button"
              className={`${styles.tabBtn} ${tab === "history" ? styles.tabBtnActive : ""}`}
              onClick={() => setTab("history")}
            >
              History
            </button>
          </div>
        </div>

        <div className={styles.monthBar}>
          <button
            type="button"
            className={styles.monthNavBtn}
            onClick={() => goMonth(-1)}
          >
            &#8249;
          </button>

          <div className={styles.monthFilter}>
            <DropDown
              label="Month"
              value={month}
              options={monthOptions}
              onSelect={(val) => setMonth(Number(val.value))}
            />
            <DropDown
              label="Year"
              value={year}
              options={yearOptions}
              onSelect={(val) => setYear(Number(val.value))}
            />
          </div>
          <button
            type="button"
            className={styles.monthNavBtn}
            onClick={() => goMonth(1)}
          >
            &#8250;
          </button>

          <button
            type="button"
            className={styles.printBtn}
            onClick={handlePrint}
          >
            Print {printLabel}
          </button>
        </div>

        <div className={styles.epsonRow}>
          <span className={styles.epsonLabel}>Thermal Printer:</span>
          <button
            type="button"
            className={styles.epsonBtn}
            disabled={printingSection === "salary"}
            onClick={() => handleEpsonPrint("salary")}
          >
            {printingSection === "salary" ? "Printing…" : "Salary Slip"}
          </button>
          <button
            type="button"
            className={styles.epsonBtn}
            disabled={printingSection === "attendance"}
            onClick={() => handleEpsonPrint("attendance")}
          >
            {printingSection === "attendance" ? "Printing…" : "Attendance"}
          </button>
          <button
            type="button"
            className={styles.epsonBtn}
            disabled={printingSection === "paidHistory"}
            onClick={() => handleEpsonPrint("paidHistory")}
          >
            {printingSection === "paidHistory" ? "Printing…" : "Total Paid"}
          </button>
          <button
            type="button"
            className={styles.epsonBtn}
            disabled={printingSection === "history"}
            onClick={() => handleEpsonPrint("history")}
          >
            {printingSection === "history" ? "Printing…" : "History"}
          </button>
        </div>

        {tab === "attendance" && (
          <>
            <div className={styles.legend}>
              {EDITABLE_STATUSES.map((s) => (
                <span key={s} className={styles.legendItem}>
                  <i style={{ background: STATUS_COLORS[s].border }} />
                  {s}
                </span>
              ))}
              <span className={`${styles.legendItem} ${styles.legendHint}`}>
                Click a day to edit
              </span>
            </div>

            <div className={styles.weekRow}>
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
                <div key={d} className={styles.weekHead}>
                  {d}
                </div>
              ))}
            </div>

            <div className={styles.calendarGrid}>
              {grid.map((date, idx) => {
                if (!date)
                  return <div key={idx} className={styles.dayCellEmpty} />;
                const status = statusByDate[date];
                const leaveTypeForDay = leaveTypeByDate[date];
                const color = status ? STATUS_COLORS[status] : null;
                const dayNum = Number(date.slice(-2));
                const isEditing = editingDate === date;

                return (
                  <div key={date} className={styles.dayCellWrap}>
                    <button
                      type="button"
                      className={`${styles.dayCell} ${isEditing ? styles.dayCellSelected : ""}`}
                      style={
                        color
                          ? {
                              background: mode ? color.dark : color.light,
                              borderColor: color.border,
                            }
                          : {}
                      }
                      onClick={(e) => handleDayCellClick(e, date)}
                      title={
                        status
                          ? `${status}${leaveTypeForDay ? ` — ${leaveTypeForDay}` : ""}`
                          : "No record — click to set"
                      }
                    >
                      <span className={styles.dayNum}>{dayNum}</span>
                      {status && (
                        <span className={styles.dayStatus}>{status}</span>
                      )}
                      {status === "Leave" && leaveTypeForDay && (
                        <span className={styles.dayLeaveTag}>
                          {leaveTypeForDay}
                        </span>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>

            <div className={styles.summaryRow}>
              <div>
                <strong>{slip.counts.Present}</strong>
                <span>Present</span>
              </div>
              <div>
                <strong>{slip.counts.Absent}</strong>
                <span>Absent</span>
              </div>
              <div>
                <strong>{slip.counts["Half-Day"]}</strong>
                <span>Half-Day</span>
              </div>
              <div>
                <strong>{slip.counts.Leave}</strong>
                <span>Leave</span>
              </div>
              <div>
                <strong>{slip.unmarkedDays}</strong>
                <span>Unmarked</span>
              </div>
            </div>
          </>
        )}

        {tab === "salary" && (
          <div className={styles.slip}>
            <table className={styles.slipTable}>
              <tbody>
                <tr>
                  <td>Days in month</td>
                  <td>{slip.daysInMonth}</td>
                </tr>
                <tr>
                  <td>Present</td>
                  <td>{slip.counts.Present}</td>
                </tr>
                <tr>
                  <td>Half-Day</td>
                  <td>{slip.counts["Half-Day"]}</td>
                </tr>
                <tr>
                  <td>Absent</td>
                  <td>{slip.counts.Absent}</td>
                </tr>
                <tr>
                  <td>Leave</td>
                  <td>{slip.counts.Leave}</td>
                </tr>
                <tr>
                  <td>Payable days</td>
                  <td>{slip.payableDays}</td>
                </tr>
                <tr>
                  <td>Per-day rate</td>
                  <td>&#8377;{slip.dailyRate.toFixed(2)}</td>
                </tr>
                <tr className={styles.slipDivider}>
                  <td colSpan={2} />
                </tr>
                <tr>
                  <td>Gross salary</td>
                  <td>
                    <span className={styles.salaryEditWrap}>
                      &#8377;{" "}
                      <input
                        type="number"
                        min="0"
                        className={styles.salaryInput}
                        value={salaryDraft}
                        onChange={(e) => setSalaryDraft(e.target.value)}
                        onBlur={handleSalaryBlur}
                        onKeyDown={(e) =>
                          e.key === "Enter" && e.currentTarget.blur()
                        }
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Deductions</td>
                  <td>- &#8377;{slip.deduction.toLocaleString("en-IN")}</td>
                </tr>
                <tr className={styles.slipTotal}>
                  <td>Net pay</td>
                  <td>&#8377;{slip.netPay.toLocaleString("en-IN")}</td>
                </tr>
              </tbody>
            </table>
            <p className={styles.editHint}>
              Edit gross salary above — it recalculates net pay automatically.
            </p>
          </div>
        )}

        {tab === "paidHistory" && (
          <div className={styles.paidHistory}>
            <div className={styles.paidHeadline}>
              <span>Total paid since joining</span>
              <strong>
                &#8377;{paidHistory.totalPaid.toLocaleString("en-IN")}
              </strong>
            </div>
            <p className={styles.subtext}>
              {paidHistory.monthsCount} month
              {paidHistory.monthsCount === 1 ? "" : "s"} counted, from{" "}
              {fmtDate(paidHistory.joiningDate)} through {MONTH_NAMES[month]}{" "}
              {year}.
            </p>

            <ul className={styles.paidHistoryList}>
              <li className={styles.paidHistoryHeader}>
                <div>Month</div>
                <div>Present</div>
                <div>Absent</div>
                <div>Half-Day</div>
                <div>Net Paid</div>
              </li>
              {paidHistory.monthlySlips.map((s) => (
                <li
                  key={`${s.year}-${s.month}`}
                  className={styles.paidHistoryRow}
                >
                  <div>
                    {MONTH_NAMES[s.month]} {s.year}
                  </div>
                  <div>{s.counts.Present}</div>
                  <div>{s.counts.Absent}</div>
                  <div>{s.counts["Half-Day"]}</div>
                  <div className={styles.netPayCell}>
                    &#8377;{s.netPay.toLocaleString("en-IN")}
                  </div>
                </li>
              ))}
            </ul>

            <div className={styles.paidTotalsRow}>
              <div>Gross across period</div>
              <div>&#8377;{paidHistory.totalGross.toLocaleString("en-IN")}</div>
            </div>
            <div className={styles.paidTotalsRow}>
              <div>Total deductions</div>
              <div>
                - &#8377;{paidHistory.totalDeduction.toLocaleString("en-IN")}
              </div>
            </div>
            <div
              className={`${styles.paidTotalsRow} ${styles.paidTotalsGrand}`}
            >
              <div>Total paid</div>
              <div>&#8377;{paidHistory.totalPaid.toLocaleString("en-IN")}</div>
            </div>
          </div>
        )}

        {tab === "history" && (
          <div className={styles.historyTab}>
            <p className={styles.subtext}>
              Every attendance and salary edit made for {employee.name}, most
              recent first.
            </p>

            {employeeHistory.length === 0 ? (
              <p className={styles.historyEmpty}>
                No edits recorded yet — changes you make in Attendance or Salary
                Slip will show up here.
              </p>
            ) : (
              <ul className={styles.historyList}>
                {employeeHistory.map((entry) => (
                  <li key={entry.id} className={styles.historyRow}>
                    <span
                      className={styles.historyDot}
                      style={{
                        background:
                          entry.type === "salary"
                            ? "#4164E3"
                            : STATUS_COLORS.default.border,
                      }}
                    />
                    <div className={styles.historyBody}>
                      <span className={styles.historyDescription}>
                        {entry.description}
                      </span>
                      <span className={styles.historyTimestamp}>
                        {formatDateTime(entry.timestamp)}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>

      {/* Portal-rendered day popover. Rendering into document.body instead
          of inline inside the calendar cell is what fixes the clipping bug:
          `.card` has overflow-y: auto, which forces the other axis to clip
          as well, so an absolutely-positioned popover for a date near the
          bottom of the grid was getting cut off. Position is computed in
          handleDayCellClick from the clicked cell's bounding rect. */}
      {editingDate &&
        popoverPos &&
        createPortal(
          <div
            ref={popoverRef}
            className={`${styles.dayPopover} ${mode ? styles.dayPopoverDark : ""}`}
            style={{
              position: "fixed",
              top: popoverPos.top,
              left: popoverPos.left,
              width: DAY_POPOVER_WIDTH,
              margin: 0,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {EDITABLE_STATUSES.map((s) => (
              <button
                key={s}
                type="button"
                className={styles.dayPopoverItem}
                style={{ color: STATUS_COLORS[s].border }}
                onClick={() => handlePickStatus(editingDate, s)}
              >
                <i style={{ background: STATUS_COLORS[s].border }} />
                {s}
              </button>
            ))}

            {leaveTypes.length > 0 && (
              <>
                <div className={styles.dayPopoverDivider} />
                <div className={styles.dayPopoverSectionLabel}>Leave type</div>
                {leaveTypes.map((lt) => {
                  const isActive =
                    statusByDate[editingDate] === "Leave" &&
                    leaveTypeByDate[editingDate] === lt;
                  return (
                    <button
                      key={lt}
                      type="button"
                      className={`${styles.dayPopoverItem} ${styles.dayPopoverLeaveItem} ${
                        isActive ? styles.dayPopoverItemActive : ""
                      }`}
                      onClick={() => handlePickStatus(editingDate, "Leave", lt)}
                    >
                      {lt}
                    </button>
                  );
                })}
              </>
            )}

            {(statusByDate[editingDate] || leaveTypeByDate[editingDate]) && (
              <button
                type="button"
                className={`${styles.dayPopoverItem} ${styles.dayPopoverClear}`}
                onClick={() => handlePickStatus(editingDate, null)}
              >
                Clear
              </button>
            )}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default EmployeeDetailModal;
